import "./styles.css";
import { Form } from "../Form/Form";
import { useTranslation } from "react-i18next";

export const InfoCollection = ({ questionsData, onComplete }) => {
  const { i18n } = useTranslation();

  const loadNextStep = (data) => {
    onComplete({ ...data, lang: i18n.language });
  };

  return <Form formData={questionsData} onComplete={loadNextStep} />;
};
